export class AmountDetails {
  constructor ({ min = null, max = null, isWholeAmountValueRequired = false, options = [] } = {}) {
    this.min = min
    this.max = max
    this.isWholeAmountValueRequired = isWholeAmountValueRequired
    // Options are for fixed items, containing the possible fixed values
    this.options = options
  }
}
